export default __webpack_public_path__ + "static/media/icon-algocare-n@2x.ec2f3e00.webp";